import { gql } from 'graphql-request';

export const GET_SHIPMENT_TASK_SCHEME = gql`
  query App5182dd71_Document($documentId: String!) {
    app5182dd71_ShipmentTask {
      getTemplate(documentId: $documentId) {
        template {
          step
          name
          type
          value
          required
          disabled
          isSearchable
          placeholder
          fieldTransform
          fieldType
          label {
            en
            ru
          }
          stepLabel
          validation
          options {
            label
            value
          }
        }
      }
    }
  }
`;
